const ranked = [
  'da',
  'en-GB',
  'sv',
  'en-US',
  'de',
  'fr',
  'no',
  'fi',
  'nl',
  'it',
  'pl',
  'en-ZA',
  'ru',
  'zh',
  'cs',
  'en-AU',
  'pt-BR',
  'ar',
  'ja',
  'hu',
  'tr',
  'ro',
]

const languages = [
  { key: 'bel', uid: 950 },
  { key: 'cat', uid: 926 },
  { key: 'ceb', uid: 948 },
  { key: 'ar', uid: 4 },
  { key: 'es-CO', uid: 792 },
  { key: 'bg', uid: 6 },
  { key: 'zh', uid: 8 },
  { key: 'hr', uid: 10 },
  { key: 'cs', uid: 12 },
  { key: 'da', uid: 14 },
  { key: 'nl', uid: 15 },
  { key: 'en-IN', uid: 16 },
  { key: 'en-GB', uid: 17 },
  { key: 'en-US', uid: 18 },
  { key: 'et', uid: 19 },
  { key: 'ewe', uid: 949 },
  { key: 'fi', uid: 20 },
  { key: 'fr-CA', uid: 21 },
  { key: 'fr', uid: 22 },
  { key: 'de', uid: 23 },
  { key: 'el', uid: 24 },
  { key: 'hi', uid: 25 },
  { key: 'iw', uid: 26 },
  { key: 'hu', uid: 27 },
  { key: 'is', uid: 28 },
  { key: 'en-IE', uid: 29 },
  { key: 'it', uid: 30 },
  { key: 'ja', uid: 31 },
  { key: 'ko', uid: 32 },
  { key: 'lv', uid: 33 },
  { key: 'lt', uid: 34 },
  { key: 'mr', uid: 35 },
  { key: 'no', uid: 36 },
  { key: 'pl', uid: 37 },
  { key: 'pt-BR', uid: 38 },
  { key: 'pa', uid: 40 },
  { key: 'ro', uid: 41 },
  { key: 'ru', uid: 42 },
  { key: 'sa', uid: 43 },
  { key: 'sr', uid: 44 },
  { key: 'sk', uid: 45 },
  { key: 'es-MX', uid: 48 },
  { key: 'sv', uid: 49 },
  { key: 'tl', uid: 50 },
  { key: 'zh-Hant-TW', uid: 51 },
  { key: 'ta', uid: 52 },
  { key: 'th', uid: 53 },
  { key: 'tr', uid: 54 },
  { key: 'uk', uid: 55 },
  { key: 'ur', uid: 56 },
  { key: 'vi', uid: 57 },
  { key: 'id-ID', uid: 59 },
  { key: 'id-MY', uid: 61 },
  { key: 'yue', uid: 62 },
  { key: 'mk', uid: 117 },
  { key: 'en-SG', uid: 816 },
  { key: 'en-AU', uid: 240 },
  { key: 'en-CA', uid: 242 },
  { key: 'en', uid: 18 },
  { key: 'mt', uid: 310 },
  { key: 'as', uid: 450 },
  { key: 'bn', uid: 451 },
  { key: 'kn', uid: 452 },
  { key: 'ml', uid: 453 },
  { key: 'or', uid: 455 },
  { key: 'te', uid: 457 },
  { key: 'ce', uid: 460 },
  { key: 'sl', uid: 510 },
  { key: 'gd', uid: 518 },
  { key: 'gu', uid: 524 },
  // { key: 'fr-FR', uid: 22 }, -- https://my.arnsbogroup.com/company/personal/user/946/tasks/task/view/70014/
  // { key: 'es', uid: 47 }, -- https://my.arnsbogroup.com/company/personal/user/73/tasks/task/view/85810/
  { key: 'pt', uid: 39 },
  { key: 'de_AT', uid: 534 },
  { key: 'bs', uid: 532 },
  { key: 'kk', uid: 533 },
  { key: 'en-NZ', uid: 538 },
  { key: 'ha', uid: 539 },
  { key: 'yo', uid: 540 },
  { key: 'kl', uid: 542 },
  { key: 'zu', uid: 543 },
  { key: 'cy-GB', uid: 544 },
  { key: 'cy', uid: 545 },
  { key: 'st', uid: 546 },
  { key: 've', uid: 547 },
  { key: 'ss', uid: 548 },
  { key: 'nso', uid: 549 },
  { key: 'tn', uid: 550 },
  { key: 'sw', uid: 551 },
  { key: 'xh', uid: 552 },
  { key: 'af', uid: 553 },
  { key: 'nd', uid: 554 },
  { key: 'de_CH', uid: 556 },
  { key: 'sq', uid: 557 },
  { key: 'es-PE', uid: 797 },
  { key: 'es-la_AR', uid: 565 },
  { key: 'it_CH', uid: 558 },
  { key: 'mis', uid: 560 },
  { key: 'fa', uid: 561 },
  { key: 'fro', uid: 947 },
  { key: 'so', uid: 562 },
  { key: 'az', uid: 563 },
  { key: 'ka', uid: 566 },
  { key: 'fr_CH', uid: 570 },
  { key: 'es-la_VE', uid: 571 },
  { key: 'es-la_CL', uid: 796 },
  { key: 'hy', uid: 798 },
  { key: 'km', uid: 799 },
  { key: 'lo', uid: 800 },
  { key: 'es-la_EC', uid: 801 },
  { key: 'lb', uid: 833 },
  { key: 'my', uid: 838 },
  { key: 'fi-SE', uid: 839 },
  { key: 'en-ARIN', uid: 840 },
  { key: 'kmr', uid: 846 },
  { key: 'ps', uid: 849 },
  { key: 'fil', uid: 852 },
  { key: 'fr_ZA', uid: 855 },
  { key: 'en-GH', uid: 868 },
  { key: 'en-NG', uid: 869 },
  { key: 'ti', uid: 870 },
  { key: 'am', uid: 871 },
  { key: 'kar', uid: 872 },
  { key: 'orm', uid: 873 },
  { key: 'en-ZA', uid: 877 },
  { key: 'mg', uid: 880 },
  { key: 'en-PH', uid: 881 },
  { key: 'nya', uid: 882 },
  { key: 'sn', uid: 883 },
  { key: 'en-KE', uid: 885 },
  { key: 'mn', uid: 886 },
  { key: 'ts', uid: 888 },
  { key: 'rw', uid: 892 },
  { key: 'bm', uid: 893 },
  { key: 'wo', uid: 894 },
  { key: 'bem', uid: 895 },
  { key: 'si', uid: 896 },
  { key: 'ig', uid: 898 },
  { key: 'ln', uid: 899 },
  { key: 'sv-FI', uid: 900 },
  { key: 'ne', uid: 903 },
  { key: 'ny', uid: 907 },
  { key: 'ber', uid: 910 },
  { key: 'tw', uid: 911 },
  { key: 'fr-BE', uid: 912 },
  { key: 'se', uid: 915 },
  { key: 'en-CC', uid: 920 },
  { key: 'fr-IC', uid: 921 },
  { key: 'sw-TZ', uid: 922 },
  { key: 'ht', uid: 924 },
  { key: 'ckb', uid: 828 },
  { key: 'ckb-IQ', uid: 843 },
  { key: 'en-002', uid: 241 },
  { key: 'en-145', uid: 897 },
  { key: 'en-SC', uid: 541 },
  { key: 'es-150', uid: 46 },
  { key: 'es-419', uid: 47 },
  { key: 'fa-001', uid: 535 },
  { key: 'fa-AF', uid: 860 },
  { key: 'kj', uid: 901 },
  { key: 'kqn', uid: 914 },
  { key: 'lg', uid: 884 },
  { key: 'lun', uid: 913 },
  { key: 'mnk', uid: 906 },
  { key: 'nl-BE', uid: 63 },
  { key: 'pt-002', uid: 879 },
  { key: 'pt-150', uid: 39 },
  { key: 'rn', uid: 908 },
  { key: 'ny', uid: 927 },
  { key: 'luo', uid: 928 },
  { key: 'en-011', uid: 929 },
  { key: 'en-014', uid: 930 },
  { key: 'mfe', uid: 931 },
  { key: 'gl', uid: 932 },
  { key: 'fng', uid: 933 },
  { key: 'pt-AO', uid: 934 },
  { key: 'pt-MZ', uid: 935 },
  { key: 'pcm', uid: 887 },
  { key: 'kir', uid: 936 },
  { key: 'toi', uid: 937 },
  { key: 'lbn', uid: 940 },
  { key: 'lue', uid: 941 },
  { key: 'tgk', uid: 942 },
  { key: 'mng', uid: 943 },
  { key: 'baq', uid: 944 },
  { key: 'bal', uid: 945 },
  { key: 'she', uid: 946 },
  { key: 'sw-UG', uid: 951 },
  { key: 'en-UG', uid: 952 },
  { key: 'aii', uid: 953 },
  { key: 'vmw', uid: 954 },
  { key: 'hil', uid: 956 },
  { key: 'ilo', uid: 957 },
  { key: 'nyn', uid: 958 },
]

const list = languages.map((language) => {
  if (ranked.includes(language.key)) {
    language.top = true
  }

  return language
})

export default list
